module.exports = __webpack_public_path__ + "img/Left_menu_bg.adde5184.svg";